import PropTypes from 'prop-types';
import { LinkButton } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { useEffect, useState } from 'react';
import { m as motion } from 'framer-motion';
import { useToggle } from '../custom-hooks/toggle';

const childrenWrapperStyles = css`
  overflow-y: hidden;
`;

const motionVariants = {
  expanded: {
    height: 'auto',
  },
  collapsed: {
    height: '60px',
  },
};

const readMoreStyles = css`
  font-size: 0.875rem;
`;

const getCharacterCount = (children) => {
  if (typeof children === 'string' || children instanceof String) {
    return children.length;
  }

  return children?.props?.content?.length ?? 0;
};

const shouldDisplayToggle = (children) => {
  const device = window.innerWidth <= 479 ? 'mobile' : 'desktop';
  const characterLimit = {
    mobile: 200,
    desktop: 700,
  };

  return getCharacterCount(children) > characterLimit[device];
};

const ReadMore = ({ children }) => {
  const { isOpen, handleToggle } = useToggle(false);
  const { t } = useTranslation();
  const [displayToggle, setDisplayToggle] = useState(false);

  useEffect(() => {
    setDisplayToggle(shouldDisplayToggle(children));
  }, [children]);

  return (
    <>
      <motion.div
        animate={displayToggle && !isOpen ? 'collapsed' : 'expanded'}
        className={childrenWrapperStyles}
        data-testid="read-more-text-wrapper"
        transition={{ type: 'tween', duration: 0.3 }}
        variants={motionVariants}
      >
        {children}
      </motion.div>

      {displayToggle && (
        <LinkButton
          className={readMoreStyles}
          data-testid="read-more-button"
          onClick={handleToggle}
        >
          {t(isOpen ? 'ReadLess' : 'ReadMore')}
        </LinkButton>
      )}
    </>
  );
};

ReadMore.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};

export default ReadMore;
